export const parseJSON = (jsonStr, defaultValue) => {
    try {
        const parsed = JSON.parse(jsonStr);
        return parsed;
    }
    catch (error) {
        return defaultValue;
    }
};
